import { Box, Button, Typography } from "@mui/material";
import { useNavigate } from "react-router-dom";

export default function OrderTableOrderIdCell({ rowData }: any) {
  const navigate = useNavigate();
  const onOrderIdClick = () => {
    navigate(`/orders/Order #(${rowData?.orderNumber})`, {
      state: rowData,
    });
  };
  return (
    <Box>
      <Button sx={{ textTransform: "none" }} onClick={onOrderIdClick}>
        <Typography>{rowData.orderNumber}</Typography>
      </Button>
    </Box>
  );
}
